import { createStore, createHook } from '@atlassian/react-sweet-state';

const goalCounterStore = createStore({
	initialState: {
		goalsCount: 0,
		yellowFlagForGoalCount: false,
		redFlagForGoalCount: false,
		shouldFocusOnAddSlaButton: false,
	},
	actions: {
		incrementGoalCounter:
			(goalCount) =>
			({ setState, getState }) => {
				setState({
					goalsCount: getState().goalsCount + goalCount,
				});
			},
		setGoalCounter:
			(goalCount) =>
			({ setState }) => {
				setState({
					goalsCount: goalCount,
				});
			},
		resetGoalCounter:
			() =>
			({ setState }) => {
				setState({
					goalsCount: 0,
				});
			},
		decrementGoalCounter:
			() =>
			({ setState, getState }) => {
				setState({
					goalsCount: getState().goalsCount - 1,
				});
			},
		setYellowFlagGoalCounter:
			(currentState) =>
			({ setState }) => {
				setState({
					yellowFlagForGoalCount: currentState,
				});
			},
		setRedFlagForGoalCount:
			(currentState) =>
			({ setState }) => {
				setState({
					redFlagForGoalCount: currentState,
				});
			},
		setShouldFocusOnAddSlaButton:
			(currentState) =>
			({ setState }) => {
				setState({
					shouldFocusOnAddSlaButton: currentState,
				});
			},
	},
});

const useGoalCounter = createHook(goalCounterStore);

export { useGoalCounter, goalCounterStore };
